import { put, call, all, takeEvery, takeLatest } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import {
  list as groupsList,
  add as groupAdd,
  get as groupGet,
  update as groupUpdate,
  del as groupDelete,
  search as groupsSearch,
  searchMembers as groupMemberSearch,
  members as groupGetMembers,
  addMembers as addMembersToGroup,
  searchBanMembers as groupBannedMemberSearch,
  getBanMembers as groupGetBannedMembers,
  banMember as groupBanMember,
  kickMember as groupKickMember,
  unbanMember as groupUnbanMember,
  listGroupScopePermissions,
  getGroupScopePermissionsValues,
  updateGroupScopePermissions,
  resetGroupScopePermission,
} from 'services/groups'
import { list as usersList, search as usersSearch, updateScopeInGroup as changeScopeInGroup } from 'services/users'
import _ from 'lodash'
import { getAppHost } from 'helpers'
import actions from './actions'

export function* GROUPS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().groups.groupSearchText
    const groupsPagination = reduxStore.getState().groups.groupsListPagination
    const filters = payload.filters || {}

    let pageNo = payload.currentPage
    if (pageNo === undefined && groupsPagination.current_page !== undefined)
      pageNo = groupsPagination.current_page + 1

    const serviceFilters = { ...filters }

    if (serviceFilters.createdAt && serviceFilters.createdAt.length === 2) {
      const [fromDate, toDate] = serviceFilters.createdAt
      serviceFilters.createdAtFrom = Math.floor(new Date(`${fromDate}T00:00:00`).getTime() / 1000)
      serviceFilters.createdAtTo = Math.floor(new Date(`${toDate}T23:59:59`).getTime() / 1000)
    }
    delete serviceFilters.createdAt

    if (serviceFilters.guids && Array.isArray(serviceFilters.guids)) {
      if (serviceFilters.guids.length === 1) {
        const [guid] = serviceFilters.guids
        serviceFilters.guid = guid
        delete serviceFilters.guids
      }
    }

    if (serviceFilters.type && Array.isArray(serviceFilters.type) && serviceFilters.type.length > 0) {
      const [typeValue] = serviceFilters.type
      serviceFilters.type = typeValue
    }

    if (serviceFilters.membersCount && Array.isArray(serviceFilters.membersCount) && serviceFilters.membersCount.length > 0) {
      const [entry] = serviceFilters.membersCount
      const [operator, value] = entry.split(':')
      serviceFilters.membersCount = {
        operator,
        value: parseInt(value, 10),
      }
    }

    const success = yield call(
      groupsList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
      serviceFilters,
    )

    if (success && success.data) {
      let totalGroupCount = success.data.length
      let groupsListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        groupsListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsList: success.data,
          groupsListTotal: totalGroupCount,
          groupsListPagination,
          groupsFilters: filters,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsList: [],
          groupsListTotal: 0,
          groupsListPagination: [],
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ADD_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const filtered = {}
    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      }
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupAdd, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.GROUPS_LIST,
        payload: { currentPage: 1, filters: {}, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/groups`))
      window.triggerNotification('Group added', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GET_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { id } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupGet, id, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: success.data,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put(push(`/app/${activeApp.id}/groups`))
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* UPDATE_GROUP({ id, payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })
    const filtered = {}
    const unset = []
    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      } else {
        unset.push(k)
      }
    })
    filtered.unset = unset
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupUpdate, id, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.GROUPS_LIST,
        payload: { currentPage: 1, data: activeApp },
      })
      yield put(push(`/app/${activeApp.id}/groups`))
      window.triggerNotification('Group saved', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* DELETE_GROUP({ payload }) {
  try {
    const { id, refresh, filters } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { groupsListPagination } = reduxStore.getState().groups

    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const success = yield call(groupDelete, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupListPageNo =
        groupsListPagination !== undefined && groupsListPagination.count > 1
          ? groupsListPagination.current_page
          : 1
      yield put({
        type: actions.GROUPS_LIST,
        payload: { currentPage: groupListPageNo, filters: filters || {}, data: activeApp },
      })
      window.triggerNotification('Group deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/groups`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_GROUP_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_GROUP,
          payload: {},
        })
      }
    }
  } catch (error) {
    // no-op
  }
}

export function* SEARCH_GROUP() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().groups.groupSearchText

    const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let totalGroupCount = success.data.length
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsList: success.data,
          groupsListTotal: totalGroupCount,
          groupsListPagination: success.meta.pagination,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsListTotal: 0,
          groupsListPagination: {},
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GROUPS_LIST_FOR_MODERATION({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().groups.groupModerationSearchText
    const success = yield call(
      groupsList,
      payload.data,
      getAppHost(payload.appSettings),
      payload.currentPage,
      searchText,
    )

    if (success && success.data) {
      let totalGroupCount = success.data.length

      if (success.meta && success.meta.pagination && success.meta.pagination.total) {
        totalGroupCount = success.meta.pagination.total
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsModerationList: success.data,
          groupsModerationListTotal: totalGroupCount,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsModerationList: [],
          groupsModerationListTotal: 0,
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_GROUP_TEXT_FOR_MODERATION({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupModerationSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupModerationSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_GROUP_FOR_MODERATION,
          payload: {},
        })
      }
    }
  } catch (error) {
    // no-op
  }
}

export function* GET_GROUP_FOR_MODERATION({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { id } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupGet, id, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsModerationActive: success.data,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put(push(`/app/${activeApp.id}/group-moderation`))
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* SEARCH_GROUP_FOR_MODERATION() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().groups.groupModerationSearchText

    const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      let totalGroupCount = success.data.length
      if (success.meta && success.meta.pagination && success.meta.pagination.total) {
        totalGroupCount = success.meta.pagination.total
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsModerationList: success.data,
          groupsModerationListTotal: totalGroupCount,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsModerationListTotal: 0,
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_USER_GROUP_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupUserSearchText: '',
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupUserSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_USER_GROUP,
        })
      }
    }
  } catch (error) {
    // no-op
  }
}

export function* SEARCH_USER_GROUP() {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().groups.groupUserSearchText

    const success = yield call(groupsSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userNonGroupsList: success.data,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          userNonGroupsList: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        userNonGroupsList: [],
      },
    })
  }
}

export function* GET_GROUP_MEMBERS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })
    const { id } = payload
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().groups.groupMemberSearchText
    const groupMemberPagination = reduxStore.getState().groups.groupMembersListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && groupMemberPagination.current_page !== undefined)
      pageNo = groupMemberPagination.current_page + 1

    const success = yield call(
      groupGetMembers,
      id,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalGroupMemberCount = success.data.length
      let groupMembersListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupMemberCount = success.meta.pagination.per_page * success.meta.pagination.total_pages
        groupMembersListPagination = success.meta.pagination
      }
      const groupData = yield call(groupGet, id, payload.data, getAppHost(payload.appSettings))

      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: groupData.data,
          groupMembersList: success.data,
          groupMembersListTotal: totalGroupMemberCount,
          groupMembersListPagination,
          areGroupsLoading: false,
        },
      })
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
      yield put(push(`/app/${payload.data.id}/groups`))
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
          groupMembersList: [],
          groupMembersListTotal: 0,
          groupMembersListPagination: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_GROUP_MEMBER_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupMemberSearchText: '',
        },
      })
      const { guid } = reduxStore.getState().groups.groupsActive

      yield put({
        type: actions.GET_GROUP_MEMBERS,
        payload: {
          id: guid,
          currentPage: 1,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupMemberSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_GROUP_MEMBER,
          payload: {},
        })
      }
    }
  } catch (error) {
    // no-op
  }
}

export function* SEARCH_GROUP_MEMBER() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const activeGroup = reduxStore.getState().groups.groupsActive
    const searchText = reduxStore.getState().groups.groupMemberSearchText

    const pageNo = 1

    const success = yield call(
      groupMemberSearch,
      activeGroup.guid,
      searchText,
      activeApp,
      getAppHost(appSettings),
      pageNo,
    )

    if (success && success.data) {
      let totalGroupMemberCount = success.data.length
      let groupMembersListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupMemberCount = success.meta.pagination.per_page * success.meta.pagination.total_pages
        groupMembersListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: activeGroup,
          groupMembersList: success.data,
          groupMembersListTotal: totalGroupMemberCount,
          groupMembersListPagination,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: activeGroup,
          groupMembersList: [],
          groupMembersListTotal: 0,
          groupMembersListPagination: [],
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ADD_MEMBERS_TO_GROUP({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { uids } = payload
    const { guid: addGUID } = reduxStore.getState().groups.groupsActive
    const success = yield call(addMembersToGroup, uids, addGUID, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.GET_GROUP_MEMBERS,
        payload: {
          id: addGUID,
          currentPage: 1,
        },
      })
      window.triggerNotification('User added to group', 'success')
    } else if (success.error.message !== undefined) {
      if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
        window.triggerNotification('Group action not allowed', 'error')
      } else {
        window.triggerNotification(success.error.message, 'error')
      }
    } else {
      window.triggerNotification('Some error occurred', 'error')
    }

    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* NON_PARTICIPANTS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().groups.nonParticipantSearchText
    const nonParticipantsPagination = reduxStore.getState().groups.nonParticipantsListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && nonParticipantsPagination.current_page !== undefined)
      pageNo = nonParticipantsPagination.current_page + 1
    const success = yield call(
      usersList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText || '',
    )

    if (success && success.data) {
      let totalUserCount = success.data.length
      let nonParticipantsListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonParticipantsListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantsList: success.data,
          nonParticipantsListTotal: totalUserCount,
          nonParticipantsListPagination,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantsList: [],
          nonParticipantsListTotal: 0,
          nonParticipantsListPagination: {},
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_NON_PARTICIPANT_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantSearchText: '',
        },
      })
      yield put({
        type: actions.SEARCH_NON_PARTICIPANT,
        payload: {},
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantSearchText: searchText,
        },
      })
      yield put({
        type: actions.SEARCH_NON_PARTICIPANT,
        payload: {},
      })
    }
  } catch (error) {
    // no-op
  }
}

export function* SEARCH_NON_PARTICIPANT() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const searchText = reduxStore.getState().groups.nonParticipantSearchText
    const success = yield call(usersSearch, activeApp, getAppHost(appSettings), searchText || '')

    if (success && success.data) {
      let totalUserCount = success.data.length
      let nonParticipantsListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalUserCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        nonParticipantsListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantsList: success.data,
          nonParticipantsListTotal: totalUserCount,
          nonParticipantsListPagination,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          nonParticipantsListTotal: 0,
          nonParticipantsListPagination: {},
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* CHANGE_MEMBER_SCOPE({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { guid: addGUID } = reduxStore.getState().groups.groupsActive
    const { uid, scope } = payload

    const success = yield call(
      changeScopeInGroup,
      uid,
      addGUID,
      scope,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data) {
      yield put({
        type: actions.GET_GROUP_MEMBERS,
        payload: {
          id: addGUID,
          currentPage: 1,
        },
      })
      window.triggerNotification(`Member is now a ${scope}`, 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })

      if (success.error.message !== undefined) {
        if (success.error.code === 'ERR_GROUP_NO_CLEARANCE') {
          window.triggerNotification('Group action not allowed', 'error')
        } else {
          window.triggerNotification(success.error.message, 'error')
        }
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GET_BANNED_GROUP_MEMBERS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { id } = payload
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const searchText = reduxStore.getState().groups.groupBannedMemberSearchText
    const groupBannedMemberPagination = reduxStore.getState().groups.groupBannedMembersListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && groupBannedMemberPagination.current_page !== undefined)
      pageNo = groupBannedMemberPagination.current_page + 1

    const success = yield call(
      groupGetBannedMembers,
      id,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalGroupBannedMemberCount = success.data.length
      let groupBannedMembersListPagination = []

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupBannedMemberCount =
          success.meta.pagination.per_page * success.meta.pagination.total_pages
        groupBannedMembersListPagination = success.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupBannedMembersList: success.data,
          groupBannedMembersListTotal: totalGroupBannedMemberCount,
          groupBannedMembersListPagination,
          areGroupsLoading: false,
        },
      })
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
          groupBannedMembersListTotal: 0,
          groupBannedMembersListPagination: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* ENTER_BANNED_GROUP_MEMBER_TEXT({ payload }) {
  try {
    const { searchText, clearText } = payload
    if (clearText) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupBannedMemberSearchText: '',
        },
      })
      const { guid } = reduxStore.getState().groups.groupsActive
      yield put({
        type: actions.GET_BANNED_GROUP_MEMBERS,
        payload: {
          id: guid,
          currentPage: 1,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupBannedMemberSearchText: searchText,
        },
      })
      if (searchText.length === 0 || searchText.length >= 2) {
        yield put({
          type: actions.SEARCH_BANNED_GROUP_MEMBER,
          payload: {},
        })
      }
    }
  } catch (error) {
    // no-op
  }
}

export function* SEARCH_BANNED_GROUP_MEMBER() {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const activeGroup = reduxStore.getState().groups.groupsActive
    const searchText = reduxStore.getState().groups.groupBannedMemberSearchText

    const success = yield call(
      groupBannedMemberSearch,
      activeGroup.guid,
      searchText,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data) {
      let totalGroupBannedMemberCount = success.data.length

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalGroupBannedMemberCount =
          success.meta.pagination.per_page * success.meta.pagination.total_pages
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: activeGroup,
          groupBannedMembersList: success.data,
          groupBannedMembersListTotal: totalGroupBannedMemberCount,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: activeGroup,
          groupBannedMembersList: [],
          groupBannedMembersListTotal: 0,
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* BAN_GROUP_MEMBER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { uid, guid } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupBanMember, uid, guid, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupMemberPagination = reduxStore.getState().groups.groupMembersListPagination
      const groupMembersListPrev = reduxStore.getState().groups.groupMembersList
      const currentPageItemCount = groupMembersListPrev.length
      const pageNo =
        groupMemberPagination.current_page !== undefined && currentPageItemCount !== 1
          ? groupMemberPagination.current_page
          : 1
      const pageNoForBannedGroupMembers = 1

      const memberSuccess = yield call(
        groupGetMembers,
        guid,
        activeApp,
        getAppHost(appSettings),
        pageNo,
      )

      const bannedMemberSuccess = yield call(
        groupGetBannedMembers,
        guid,
        activeApp,
        getAppHost(appSettings),
        pageNoForBannedGroupMembers,
      )
      const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
      let totalGroupMemberCount = memberSuccess.data.length
      let totalBannedGroupMemberCount = bannedMemberSuccess.data.length

      let groupMembersListPagination = []
      let groupBannedMembersListPagination = []

      if (
        memberSuccess.meta &&
        memberSuccess.meta.pagination &&
        memberSuccess.meta.pagination.total_pages
      ) {
        totalGroupMemberCount =
          memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
        groupMembersListPagination = memberSuccess.meta.pagination
      }

      if (
        bannedMemberSuccess.meta &&
        bannedMemberSuccess.meta.pagination &&
        bannedMemberSuccess.meta.pagination.total_pages
      ) {
        totalBannedGroupMemberCount =
          bannedMemberSuccess.meta.pagination.per_page *
          bannedMemberSuccess.meta.pagination.total_pages
        groupBannedMembersListPagination = bannedMemberSuccess.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: groupData.data,
          groupMembersList: memberSuccess.data,
          groupBannedMembersList: bannedMemberSuccess.data,
          groupMembersListTotal: totalGroupMemberCount,
          groupBannedMembersListTotal: totalBannedGroupMemberCount,
          groupMembersListPagination,
          groupBannedMembersListPagination,
          areGroupsLoading: false,
        },
      })
      window.triggerNotification('User has been banned', 'success')
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification('User cannot be banned', 'error')
      } else {
        window.triggerNotification('Unknown error', 'error')
        yield put(push(`/app/${activeApp.id}/groups`))
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* UNBAN_GROUP_MEMBER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { uid, guid } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupUnbanMember, uid, guid, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupBannedMemberPagination = reduxStore.getState().groups.groupBannedMembersListPagination
      const pageNoForGroupMembers = 1

      const memberSuccess = yield call(
        groupGetMembers,
        guid,
        activeApp,
        getAppHost(appSettings),
        pageNoForGroupMembers,
      )
      const groupBannedMembersListPrev = reduxStore.getState().groups.groupBannedMembersList

      const currentPageItemCount = groupBannedMembersListPrev.length
      const pageNo =
        groupBannedMemberPagination.current_page !== undefined && currentPageItemCount !== 1
          ? groupBannedMemberPagination.current_page
          : 1

      const bannedMemberSuccess = yield call(
        groupGetBannedMembers,
        guid,
        activeApp,
        getAppHost(appSettings),
        pageNo,
      )
      const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
      let totalGroupMemberCount = memberSuccess.data.length
      let totalBannedGroupMemberCount = bannedMemberSuccess.data.length
      let groupMembersListPagination = []
      let groupBannedMembersListPagination = []
      if (
        memberSuccess.meta &&
        memberSuccess.meta.pagination &&
        memberSuccess.meta.pagination.total_pages
      ) {
        totalGroupMemberCount =
          memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
        groupMembersListPagination = memberSuccess.meta.pagination
      }
      if (
        bannedMemberSuccess.meta &&
        bannedMemberSuccess.meta.pagination &&
        bannedMemberSuccess.meta.pagination.total_pages
      ) {
        totalBannedGroupMemberCount =
          bannedMemberSuccess.meta.pagination.per_page *
          bannedMemberSuccess.meta.pagination.total_pages
        groupBannedMembersListPagination = bannedMemberSuccess.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: groupData.data,
          groupMembersList: memberSuccess.data,
          groupBannedMembersList: bannedMemberSuccess.data,
          groupMembersListTotal: totalGroupMemberCount,
          groupBannedMembersListTotal: totalBannedGroupMemberCount,
          groupMembersListPagination,
          groupBannedMembersListPagination,
          areGroupsLoading: false,
        },
      })
      window.triggerNotification('User has been unbanned', 'success')
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification('User could not be unbanned', 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
        yield put(push(`/app/${activeApp.id}/groups/${guid}`))
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* KICK_GROUP_MEMBER({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { uid, guid } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(groupKickMember, uid, guid, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const groupMemberPagination = reduxStore.getState().groups.groupMembersListPagination
      const groupMembersListPrev = reduxStore.getState().groups.groupMembersList

      const currentPageItemCount = groupMembersListPrev.length
      const pageNo =
        groupMemberPagination.current_page !== undefined && currentPageItemCount !== 1
          ? groupMemberPagination.current_page
          : 1
      const memberSuccess = yield call(
        groupGetMembers,
        guid,
        activeApp,
        getAppHost(appSettings),
        pageNo,
      )
      const groupData = yield call(groupGet, guid, activeApp, getAppHost(appSettings))
      let totalGroupMemberCount = memberSuccess.data.length
      let groupMembersListPagination = []
      if (
        memberSuccess.meta &&
        memberSuccess.meta.pagination &&
        memberSuccess.meta.pagination.total_pages
      ) {
        totalGroupMemberCount =
          memberSuccess.meta.pagination.per_page * memberSuccess.meta.pagination.total_pages
        groupMembersListPagination = memberSuccess.meta.pagination
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupsActive: groupData.data,
          groupMembersList: memberSuccess.data,
          groupMembersListTotal: totalGroupMemberCount,
          groupMembersListPagination,
          areGroupsLoading: false,
        },
      })
      window.triggerNotification('User has been removed', 'success')
    } else {
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification('User could not be removed', 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
        yield put(push(`/app/${activeApp.id}/groups/${guid}`))
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GROUP_SCOPE_PERMISSIONS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      listGroupScopePermissions,
      payload.guid,
      payload.scope,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data && success.data.permissions) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsList: success.data.permissions,
          groupScopePermissionsListTotal: success.data.permissions.length || 0,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsList: [],
          groupScopePermissionsListTotal: 0,
          areGroupsLoading: false,
        },
      })
      if (success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GROUP_SCOPE_PERMISSIONS_VALUES_GET({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const { guid, scope } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      getGroupScopePermissionsValues,
      guid,
      scope,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data && success.data.permissions) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsValues: success.data.permissions,
          areGroupsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsValues: {},
          areGroupsLoading: false,
        },
      })
      if (success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GROUP_SCOPE_PERMISSIONS_UPDATE({ guid, scope, payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      updateGroupScopePermissions,
      guid,
      scope,
      payload,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data && success.data.permissions) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsValues: success.data.permissions,
          areGroupsLoading: false,
        },
      })
      window.triggerNotification('Permissions updated successfully', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
      if (success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Failed to update permissions', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export function* GROUP_SCOPE_PERMISSIONS_RESET({ guid, scope, permissionId }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      resetGroupScopePermission,
      guid,
      scope,
      permissionId,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data && success.data.permissions) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          groupScopePermissionsValues: success.data.permissions,
          areGroupsLoading: false,
        },
      })
      window.triggerNotification('Permission reset to default', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areGroupsLoading: false,
        },
      })
      if (success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Failed to reset permission', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areGroupsLoading: false,
      },
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GROUPS_LIST, GROUPS_LIST),
    takeEvery(actions.ADD_GROUP, ADD_GROUP),
    takeEvery(actions.GET_GROUP, GET_GROUP),
    takeEvery(actions.UPDATE_GROUP, UPDATE_GROUP),
    takeEvery(actions.DELETE_GROUP, DELETE_GROUP),
    takeEvery(actions.ENTER_GROUP_TEXT, ENTER_GROUP_TEXT),
    takeLatest(actions.SEARCH_GROUP, SEARCH_GROUP),
    takeEvery(actions.GROUPS_LIST_FOR_MODERATION, GROUPS_LIST_FOR_MODERATION),
    takeEvery(actions.ENTER_GROUP_TEXT_FOR_MODERATION, ENTER_GROUP_TEXT_FOR_MODERATION),
    takeEvery(actions.GET_GROUP_FOR_MODERATION, GET_GROUP_FOR_MODERATION),
    takeLatest(actions.SEARCH_GROUP_FOR_MODERATION, SEARCH_GROUP_FOR_MODERATION),
    takeEvery(actions.ENTER_USER_GROUP_TEXT, ENTER_USER_GROUP_TEXT),
    takeLatest(actions.SEARCH_USER_GROUP, SEARCH_USER_GROUP),
    takeEvery(actions.GET_GROUP_MEMBERS, GET_GROUP_MEMBERS),
    takeEvery(actions.ENTER_GROUP_MEMBER_TEXT, ENTER_GROUP_MEMBER_TEXT),
    takeLatest(actions.SEARCH_GROUP_MEMBER, SEARCH_GROUP_MEMBER),
    takeEvery(actions.ADD_MEMBERS_TO_GROUP, ADD_MEMBERS_TO_GROUP),
    takeEvery(actions.NON_PARTICIPANTS_LIST, NON_PARTICIPANTS_LIST),
    takeEvery(actions.ENTER_NON_PARTICIPANT_TEXT, ENTER_NON_PARTICIPANT_TEXT),
    takeLatest(actions.SEARCH_NON_PARTICIPANT, SEARCH_NON_PARTICIPANT),
    takeEvery(actions.CHANGE_MEMBER_SCOPE, CHANGE_MEMBER_SCOPE),
    takeEvery(actions.GET_BANNED_GROUP_MEMBERS, GET_BANNED_GROUP_MEMBERS),
    takeEvery(actions.ENTER_BANNED_GROUP_MEMBER_TEXT, ENTER_BANNED_GROUP_MEMBER_TEXT),
    takeLatest(actions.SEARCH_BANNED_GROUP_MEMBER, SEARCH_BANNED_GROUP_MEMBER),
    takeEvery(actions.BAN_GROUP_MEMBER, BAN_GROUP_MEMBER),
    takeEvery(actions.UNBAN_GROUP_MEMBER, UNBAN_GROUP_MEMBER),
    takeEvery(actions.KICK_GROUP_MEMBER, KICK_GROUP_MEMBER),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_LIST, GROUP_SCOPE_PERMISSIONS_LIST),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_VALUES_GET, GROUP_SCOPE_PERMISSIONS_VALUES_GET),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_UPDATE, GROUP_SCOPE_PERMISSIONS_UPDATE),
    takeEvery(actions.GROUP_SCOPE_PERMISSIONS_RESET, GROUP_SCOPE_PERMISSIONS_RESET),
  ])
}
